import { render, staticRenderFns } from "./DashboardVehicle.vue?vue&type=template&id=dde8ed66&scoped=true&"
import script from "./DashboardVehicle.vue?vue&type=script&lang=js&"
export * from "./DashboardVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde8ed66",
  null
  
)

export default component.exports